export default {
	startsWith: 'Beginnt mit',
	contains: 'Enthält',
	notContains: 'Nicht enthält',
	endsWith: 'Endet mit',
	equals: 'Gleich',
	notEquals: 'Nicht gleich',
	noFilter: 'Kein Filter',
	lt: 'Weniger als',
	lte: 'Gleich oder kleiner als',
	gt: 'Größer als',
	gte: 'Größer als oder gleich wie',
	dateIs: 'Datum ist',
	dateIsNot: 'Datum ist nicht',
	dateBefore: 'Datum ist vor',
	dateAfter: 'Datum ist nach',
	clear: 'Klar',
	apply: 'Bewerben',
	matchAll: 'Alle abgleichen',
	matchAny: 'Übereinstimmung mit Beliebigen',
	addRule: 'Regel hinzufügen',
	removeRule: 'Regel entfernen',
	accept: 'Ja',
	reject: 'Nein',
	choose: 'Wählen',
	upload: 'Hochladen',
	cancel: 'Absagen',
	dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
	dayNamesShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
	dayNamesMin: ['S', 'M', 'D', 'M ', 'D', 'F ', 'S'],
	monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
	monthNamesShort: ['Jan', 'Feb', 'MÃ¤r', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
	today: 'Heute',
	weekHeader: 'Woche',
	firstDayOfWeek: 1,
	dateFormat: 'yy-mm-dd',
	weak: 'Schwach',
	medium: 'Mittel',
	strong: 'Stark',
	passwordPrompt: 'Geben Sie ein Passwort ein',
	emptyFilterMessage: 'keine Ergebnisse gefunden',
	emptyMessage: 'Keine verfügbaren Optionen',
	uploadedFiles: 'Uploaded files',
	uploadFailed: 'Upload Failed',
	maxFileLimit: 'Max file limit of ${limit} execeeded!',
	aria: {
		trueLabel: "Richtig",
		falseLabel: "Falsch",
		nullLabel: "Nicht selektiert",
		pageLabel: "Seite",
		firstPageLabel: "Erste Seite",
		lastPageLabel: "Letzte Seite",
		nextPageLabel: "Nächste Seite",
		previousPageLabel: "Vorherige Seite"
	},
	validations: {
		required: "Wert ist erforderlich.",
		undefined: "Wert ist erforderlich.",
		email: "Wert ist keine gültige E-Mail-Adresse",
		minLength: "Dieses Feld sollte mindestens ${min} Zeichen lang sein",
		maxLength: "Die maximal erlaubte Länge ist ${max}",
		minValue: "Der zulässige Mindestwert ist ${min}",
		maxValue: "Der maximal erlaubte Wert ist ${max}",
		numeric: "Wert muss numerisch sein",
		ipAddress: "Der Wert ist keine gültige IP-Adresse",
		sameAs: "Der Wert muss gleich dem Wert von ${otherName} sein",
	}
}